import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  five_star_review_count: number;
}

const ReviewsCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Five-star reviews",
  accessorFn: (row) => row.five_star_review_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default ReviewsCol;
